import * as Moment from 'moment';
import { extendMoment } from 'moment-range';

export const isOverlap = (start1: Date, end1: Date, start2: Date, end2: Date) => {
    const moment = extendMoment(Moment);
    const range1 = moment.range(start1, end1);
    const range2 = moment.range(start2, end2);
    return range1.overlaps(range2);
}